import { Link } from "react-router-dom";
import { Button } from "react-bootstrap";
import { all_routes } from "../../../../../router/all_routes";
import CollapseHeader from "../../../../../../core/common/collapse-header/collapse-header";

interface LeaveHeaderProps {
    onAddLeave: () => void;
}

const LeaveHeader: React.FC<LeaveHeaderProps> = ({ onAddLeave }) => {
    return (
        <div className="d-md-flex d-block align-items-center justify-content-between page-breadcrumb mb-3">
            <div className="my-auto mb-2">
                <h2 className="mb-1">Leaves</h2>
                <nav>
                    <ol className="breadcrumb mb-0">
                        <li className="breadcrumb-item">
                            <Link to={all_routes.adminDashboard}>
                                <i className="ti ti-smart-home" />
                            </Link>
                        </li>
                        <li className="breadcrumb-item">Employee</li>
                        <li className="breadcrumb-item active" aria-current="page">
                            Leaves
                        </li>
                    </ol>
                </nav>
            </div>
            <div className="d-flex my-xl-auto right-content align-items-center flex-wrap">
                <div className="mb-2">
                    <Button
                        onClick={onAddLeave}
                        className="btn btn-primary d-flex align-items-center"
                    >
                        <i className="ti ti-circle-plus me-2" />
                        Add Leave
                    </Button>
                </div>
                <div className="head-icons ms-2">
                    <CollapseHeader />
                </div>
            </div>
        </div>
    );
};

export default LeaveHeader;
